var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { assoc, countBy, flatten, identity, isEmpty, map, propOr, reduce, repeat, } from "ramda";
import { Maybe } from "true-myth";
export default function applyStockLevel(item, cartItems, stockLevels) {
    var cartItemsCountById = countBy(identity, flatten(map(function (cartItem) {
        return repeat([cartItem.id].concat(cartItem.selectedSides.map(function (side) { return side.sideId; })), cartItem.quantity);
    }, cartItems)));
    var initialStockLevel = Maybe.of(stockLevels[item.id]);
    var stockInCart = propOr(0, item.id, cartItemsCountById);
    var remainingStock = initialStockLevel.match({
        Just: function (stockLevel) { return stockLevel - stockInCart; },
        Nothing: function () { return null; },
    });
    if (!isEmpty(item.sides)) {
        var sides = reduce(function (sidesAcc, sideItem) {
            var initialSideStockLevel = Maybe.of(stockLevels[sideItem.sideId]);
            var sideStockInCart = propOr(0, sideItem.sideId, cartItemsCountById);
            var remainingSideStock = initialSideStockLevel.match({
                Just: function (stockLevel) { return stockLevel - sideStockInCart; },
                Nothing: function () { return null; },
            });
            return sidesAcc.concat(assoc("stockLevel", Maybe.of(remainingSideStock), sideItem));
        }, [], item.sides);
        return __assign(__assign({}, item), { sides: sides, stockLevel: Maybe.of(remainingStock) });
    }
    return __assign(__assign({}, item), { stockLevel: Maybe.of(remainingStock) });
}
